import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import { Dropdown, DropdownItem, DropdownTitle } from 'components/Dropdown'
import Icon from 'components/Icon'
import Tooltip from 'components/Tooltip'
import { UserManagementViewModel } from 'user-management/views/UserManagement/UserManagementViewModel'
import Workspace from '../../../iam/models/Workspace'

interface UserManagementTableMenuProps {
  vm: UserManagementViewModel
}

export default observer(({ vm }: UserManagementTableMenuProps) => (
  <Dropdown
    autoDismiss
    position="bottom-end"
    button={
      <Tooltip content="Actions" placement="bottom">
        <Button
          size="baseline"
          type="text"
          dataTest="user-management-table-menu"
        >
          <Icon name="more" color="var(--grey600)" />
        </Button>
      </Tooltip>
    }
  >
    <DropdownTitle>Actions</DropdownTitle>
    <DropdownItem
      onClick={() => vm.workspaceInvitationVM.showWithSelections()}
      icon={<Icon name="add" color="var(--grey600)" />}
      dataTest="user-management-table-menu-invite-to-workspace"
    >
      Invite to workspace
    </DropdownItem>
    {vm.workspaceSelector.selectedWorkspace === Workspace.none &&
      vm.isPlatformAdmin &&
      vm.selectedUserIds.size >= 1 && (
        <DropdownItem
          onClick={() =>
            vm.manageUserCapacityVM.open(
              vm.selectedUserIds,
              vm.workspaceSelector.selectedWorkspace,
            )
          }
          icon={<Icon name="edit-outlined" color="var(--grey600)" />}
          dataTest="user-management-table-row-actions-manage-global-capacity"
          muteClickEvent
        >
          Manage global capacity
        </DropdownItem>
      )}

    {/* Only display these actions when filtering by a workspace and at least one user has been selected. */}
    {vm.workspaceSelector.selectedWorkspace.id &&
      vm.selectedUserIds.size > 0 && (
        <>
          {vm.userSearch.userInactiveFilter.value ? (
            <DropdownItem
              onClick={() =>
                vm.restoreToWorkspaceVM.open(
                  vm.selectedUserIds,
                  vm.workspaceSelector.selectedWorkspace,
                )
              }
              icon={<Icon name="add-people" color="var(--grey600)" />}
              dataTest="user-management-table-menu-restore-to-workspace"
            >
              Restore to workspace
            </DropdownItem>
          ) : (
            <>
              <DropdownItem
                onClick={() =>
                  vm.manageUserCapacityVM.open(
                    vm.selectedUserIds,
                    vm.workspaceSelector.selectedWorkspace,
                  )
                }
                icon={<Icon name="edit-outlined" color="var(--grey600)" />}
                dataTest="user-management-table-menu-manage-capacity"
              >
                Manage capacity
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  vm.editUserRoleVM.open(
                    vm.selectedUserIds,
                    vm.workspaceSelector.selectedWorkspace,
                  )
                }
                icon={<Icon name="edit-roles" color="var(--grey600)" />}
                dataTest="user-management-table-menu-edit-roles"
              >
                Edit roles
              </DropdownItem>
              <DropdownItem
                onClick={() => vm.manageSkillsVM.showWithSelections()}
                icon={<Icon name="edit-skills" color="var(--grey600)" />}
                dataTest="user-management-table-menu-manage-skills"
              >
                Manage skills
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  vm.removeFromWorkspaceVM.open(
                    vm.selectedUserIds,
                    vm.workspaceSelector.selectedWorkspace,
                  )
                }
                icon={<Icon name="close" color="var(--grey600)" />}
                dataTest="user-management-table-menu-remove-from-workspace"
              >
                Remove from workspace
              </DropdownItem>
            </>
          )}
        </>
      )}
  </Dropdown>
))
